import React from 'react';
import './styles.css';


function StyledButtonExternal() {
  return (
    <button className="styled-btn">External Styled Button</button>
  );
}

export default StyledButtonExternal;
